import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../utils/mockData';
import AnimatedCounter from './AnimatedCounter';

const Stats = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
      {stats.map((stat, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
          className="text-center p-6 rounded-2xl bg-gradient-to-br from-teal-50 to-green-50 hover:shadow-lg transition-all cursor-pointer"
        >
          <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-teal-600 to-green-600 bg-clip-text text-transparent mb-2">
            <AnimatedCounter value={stat.value} />
          </div>
          <div className="text-gray-700 text-sm md:text-base font-medium">{stat.label}</div>
        </motion.div>
      ))}
    </div>
  );
};

export default Stats;
